<template>
  <v-tooltip
    v-bind="{ ...$props, ...$attrs }"
    content-class="editor-toolbar-tooltips"
  >
    <template #activator="{ props: hover }">
      <span v-bind="hover">
        <slot
          name="activator"
        />
      </span>
    </template>
    <span class="editor-toolbar-tooltip-title-text">
      {{ title }}
    </span>
    <div
      v-if="shortcuts.length"
      class="editor-toolbar-tooltip-shortcuts"
    >
      <span
        v-for="shortcut in shortcuts"
        :key="shortcut"
        class="editor-toolbar-tooltip-shortcut-text ma-1"
      >{{ shortcut }}</span>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ToolbarTooltip',
  props: {
    title: {
      type: String,
      required: true,
    },
    shortcuts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="less">
.v-overlay__content.editor-toolbar-tooltips {
  background: @white !important;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 50px fade(@text-darkest, 10%);
  font-size: 14px;
  border-radius: 8px;
  opacity: 1;
  max-width: 175px;

  .editor-toolbar-tooltip-title-text {
    font-weight: 500 !important;
    color: @text-darkest;
  }

  .editor-toolbar-tooltip-shortcuts {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    margin: -4px 0px;
  }

  .editor-toolbar-tooltip-shortcut-text {
    font-weight: 300 !important;
    font-size: 12px;
    border-radius: 4px;
    background-color: fade(@text-darkest, 3%);
    color: fade(@text-darkest, 60%);
    padding: 2px;
  }
}
</style>
